import React, {useContext, useEffect, useRef, useState} from "react";
import {Context} from "../../../App";
import {useTranslation} from "react-i18next";
import DB_RemainsMobile from "../../../database/mobile/db_remains_mobile";
import ModalWindow from "../../modal";
import {Breadcrumb, Button, Col, Form, Row, Select, Space, Table} from "antd";
import {Link, Outlet, useLocation, useParams, useSearchParams} from "react-router-dom";
import {ReloadOutlined, SearchOutlined} from "@ant-design/icons";
import DB_PriceLists from "../../../database/dictionary/price-lists";
import {isNullForm} from "../../tech/check";
import axios from "axios";
import DB_Warehouse from "../../../database/dictionary/warehouse";
import Input from "antd/es/input/Input";
import Highlighter from "react-highlight-words";

const RemainMobile = () => {
    const {availability_id} = useParams()

    const {token, setToken, defaultPageSize} = useContext(Context)
    const {t} = useTranslation()
    const {getAvailability} = DB_RemainsMobile(token)
    const {branchesPriceLists} = DB_PriceLists(token)
    const {getActiveWarehouses} = DB_Warehouse(token)
    const {errorConnect} = ModalWindow()
    const [data, setData] = useState()
    const [wait, setWait] = useState(false)
    const p = new URLSearchParams(window.location.search)
    const location = useLocation()
    const controller = new AbortController()
    const [searchParams, setSearchParams] = useSearchParams()
    const [search, setSearch] = useState({});
    const [warehouses, setWarehouses] = useState([])
    const [priceLists, setPriceLists] = useState([])
    const [branchId, setBranchId] = useState()
    const [form] = Form.useForm()
    const [col, setCol] = useState([])
    const searchInput = useRef(null);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');




    const clearFilter = () => {
        form.setFieldsValue({
                warehouse: null,
                price_list: null,
            }
        )
        setSearch(current => {
            const {branch, ...rest} = current
            return rest
        })

        setSearch(current => {
            const {price_list, ...rest} = current
            return rest
        })
    }

    const setFilter = () => {
        if (isNullForm(form.getFieldValue('warehouse'))) {
            setSearch(current => {
                const {warehouse, ...rest} = current
                return rest
            })
        } else {
            setSearch(c => ({
                ...c,
                warehouse: form.getFieldValue('warehouse')
            }))
        }

        if (isNullForm(form.getFieldValue('price_list'))) {
            setSearch(current => {
                const {price_list, ...rest} = current
                return rest
            })
        } else {
            setSearch(c => ({
                ...c,
                price_list: form.getFieldValue('price_list')
            }))
        }
    }

    const getData = () => {
        if (wait) {
            controller.abort()
        }
        setWait(true)

        searchParams.append('id', availability_id)

        getAvailability(controller, searchParams)
            .then(res => {
                setData(res.data.details)
                setBranchId(res.data.branch_id)

                form.setFieldsValue({
                        warehouse: res.data.warehouse_id
                    }
                )
                setCol(columns)
                if (p.has('price_list')) {
                    setCol(columns.concat([{
                        title: t('price'),
                        dataIndex: 'price',
                    },]))
                }
            })
            .catch((e) => {
                setWait(false)
                if (!axios.isCancel(e)) {
                    if (e.status.code === 403) {
                        setToken(null)
                    } else {
                        errorConnect()
                    }
                }
            })
            .finally(() => {
                setWait(false)
            })
    }

    useEffect(() => {
        setSearchParams(search)
    }, [search])

    useEffect(() => {
        getData()
    }, [searchParams])

    useEffect(() => {
        axios.all([branchesPriceLists(branchId), getActiveWarehouses(branchId)])
            .then(axios.spread((priceLists, warehousesList) => {
                setPriceLists(priceLists.data)
                setWarehouses(warehousesList.data)
            })).catch((e) => {
            if (e.request.status === 403) {
                setToken(null)
            } else {
                errorConnect()
            }
        });
    }, [branchId])


    useEffect(() => {
        window.scrollTo(0, 0)
        if (p.has('warehouse')) {
            form.setFieldsValue({
                    warehouse: parseInt(p.get("warehouse"))
                }
            )
            setSearch(c => ({
                ...c,
                warehouse: p.get("warehouse")
            }))
        }

        if (p.has('price_list')) {
            form.setFieldsValue({
                    price_list: parseInt(p.get("price_list"))
                }
            )
            setSearch(c => ({
                ...c,
                price_list: p.get("price_list")
            }))
        }
    }, [])



    const Filters = () => {
        return (
            <>
                <Form
                    form={form}
                    name="advanced_search"
                    className="ant-advanced-search-form"
                    layout={"vertical"}
                    style={{marginTop: '20pt'}}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            setFilter()
                        }
                    }}
                >
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                name='warehouse'
                                label={t('warehouse')}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="name"
                                    optionLabelProp="name"
                                    allowClear>
                                    {warehouses.map(b =>
                                        <Select.Option key={b.id} value={b.id} name={b.name}>{b.name}</Select.Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name='price_list'
                                label={t('price_list')}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="name"
                                    optionLabelProp="name"
                                    allowClear>
                                    {priceLists.map(b =>
                                        <Select.Option key={b.id} value={b.id} name={b.name}>{b.name}</Select.Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

                <Space
                    style={{marginTop: '-10pt', marginBottom: '20pt', width: '100%', justifyContent: 'flex-end'}}>
                    <Button icon={<ReloadOutlined />} onClick={clearFilter}>{t('clear')}</Button>
                    <Button type={"primary"} icon={<SearchOutlined/>}
                            onClick={setFilter}>{t('search')}</Button>
                </Space>

            </>
        )
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (confirm, setSelectedKeys) => {
        setSelectedKeys([]);
        confirm();
        setSearchText('');
        setSearchedColumn('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div
                style={{
                    padding: 8,
                }}
            >
                <Input
                    ref={searchInput}
                    placeholder={"ID " + t('vendor_code')}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        {t('search')}
                    </Button>
                    <Button
                        onClick={() => handleReset(confirm, setSelectedKeys)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        {t('reset')}
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={
                        text ? text.toString() : ''
                    }/>
            ) : (
                text
            ),
    })

    const columns = [
        {
            title: t('ID'),
            dataIndex: 'vendor_code_id',
            ...getColumnSearchProps('vendor_code_id'),


        },
        {
            title: t('vendor_code'),
            dataIndex: 'vendor_code_name',
        },
        {
            title: t('quantity'),
            dataIndex: 'remain',
        },
    ]

    return (
        <div>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('availability')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <Link key='1' to={"/site/app/availability"}>
                            <Button type={'default'} shape={'round'}>{t('back')}</Button>
                        </Link>
                    </Space>
                </Space>

                <Filters/>

                <Table
                    columns={col}
                    dataSource={data}
                    rowKey="id"
                    loading={wait}
                    size={"small"}
                    style={{'--cursor': "auto" }}
                    pagination={false}

                />

            </div>
            <Outlet/>
        </div>
    )
}

export default RemainMobile